import $ from 'jquery';
import Waypoint from 'waypoints';
import {getIsSubscribed} from '../utilities/subscription-cookie';
import {getPageCount} from '../utilities/page-counter';
import {setDismissedPopup, getDismissedPopup} from '../utilities/dismissed-popup-cookie';

class Popup {
  static minimumPageViewCount = 6;

  constructor() {
    this.nodes = {
      $body: $('body'),
      $closeTrigger: $('.js-popup-close'),
    };

    this.classes = {
      activeClass: 'js-visible-popup',
    };

    this.nodes.$closeTrigger.on('click', () => {
      this.closePopup();
      setDismissedPopup(true);
    });

    this.handleOpen();
  }

  openPopup() {
    this.nodes.$body.addClass(this.classes.activeClass);
  }

  closePopup() {
    this.nodes.$body.removeClass(this.classes.activeClass);
  }

  eligible() {
    return !getIsSubscribed() &&
      !getDismissedPopup() &&
      (getPageCount() >= this.constructor.minimumPageViewCount);
  }

  handleOpen() {
    new Waypoint({
      element: document.getElementById('ExchangeMainNav'),
      handler: () => {
        if (this.eligible()) {
          this.openPopup();
        }
      },
      offset: '-50%',
    });
  }
}

export default Popup;
